export default __webpack_public_path__ + "static/media/st_logo.358bab48.png";